import {MAT_SNACK_BAR_DATA} from '@angular/material/snack-bar';
import {Component, Inject} from "@angular/core";
import {DatePipe, NgIf} from "@angular/common";
import {MatCard} from "@angular/material/card";
import {MatIcon} from "@angular/material/icon";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: '',
  template: `<mat-icon>{{ data?.icon }}</mat-icon> <span>{{ data?.message | translate }}</span>`,
  styles: `
    :host {
      display: flex;
    }
  `,
  standalone: true,
  imports: [NgIf, MatCard, MatIcon, DatePipe, TranslateModule]
})

export class SnackBarWithIconComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {
  }
}
